import React from 'react'
import { NavLink } from 'react-router-dom'
import { Language } from '../language'
import { WorkshopMenuItem } from '../Models/workshopMenu'

import './WorkshopNav.scss'

export interface WorkshopsNavProps { 
	workshopMenuItems: Array<WorkshopMenuItem>
	language: Language
}

function getWorkshopLink(menuItem: WorkshopMenuItem) {
	return menuItem.page || `/${menuItem.workshopId}`
}

function WorkshopNavComponent(props: WorkshopsNavProps) {

	const menuItemElements: Array<React.ReactElement> = []

	for (let menuIndex = 0; menuIndex < props.workshopMenuItems.length; menuIndex++) {
		const menuItem = props.workshopMenuItems[menuIndex]

		// we have a menu header
		if (menuItem.type == 'header') {

			// just a header as a separator element
			let menuItemElement = (
				<p key={menuIndex} className='menu-label'>
					{menuItem.text[props.language]}
				</p>
			)

			// we can have clickable headers
			if (menuItem.workshopId || menuItem.page) {

				menuItemElement = (
					<p key={menuIndex} className='menu-label'>
						<NavLink to={getWorkshopLink(menuItem)} className={({isActive}) => isActive ? 'is-active' : '' }>
							{menuItem.text[props.language]}
						</NavLink>
					</p>
				)
			}

			menuItemElements.push(menuItemElement)
		}
		// we have a workshop menu item.   
		else {
			
			// Find next header
			let nextMenuHeaderIndex = props.workshopMenuItems.slice(menuIndex+1).findIndex(mi => mi.type == 'header') 

			if (nextMenuHeaderIndex === -1) {
				nextMenuHeaderIndex = props.workshopMenuItems.length
			}
			else nextMenuHeaderIndex += (menuIndex + 1)

			if (nextMenuHeaderIndex < 0) nextMenuHeaderIndex = props.workshopMenuItems.length

			// create workshop menu items
			const workshopMenuItems = props.workshopMenuItems.slice(menuIndex, nextMenuHeaderIndex).map((menuItem, menuItemIndex) => {

				return (
					<li key={menuItemIndex}>
						<NavLink to={getWorkshopLink(menuItem)} className={({ isActive }) => isActive ? 'is-active' : ''}>
							{menuItem.text[props.language]}
						</NavLink>
					</li>
				)
			})

			if (workshopMenuItems.length > 0) {
				menuItemElements.push(
					<ul key={menuIndex} className='menu-list'>
						{workshopMenuItems}
					</ul>
				)
			
				menuIndex = nextMenuHeaderIndex - 1
			}
		}
	}

	return (
		<aside className='menu'>
			{menuItemElements}
		</aside>
	)
}

export const WorkshopNav = React.memo(WorkshopNavComponent)

export default WorkshopNav

